module.exports = (__webpack_require__("UAjq"))("BOC/");